import { render, staticRenderFns } from "./ChangeCardModal.vue?vue&type=template&id=97d9205c&"
import script from "./ChangeCardModal.vue?vue&type=script&lang=js&"
export * from "./ChangeCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports